import LegalPage from "@/components/landing/LegalPage";

const SECTIONS = [
    {
        heading: "1. The service",
        body: "Ago GenApp is a privacy-first family story application operated by Ago GenApp at agogenapp.com (contact: hello@agogenapp.com). It provides a private space to store, organize, and share family photos, videos, voice recordings, written stories, and life milestones with invited family members. The service is live and open for registration; the first 100 registered families receive Founding status with the benefits described on the website.",
    },
    {
        heading: "2. Accounts & eligibility",
        body: "You must be at least 18 years old to create an account or make a contribution. You are responsible for keeping your login credentials confidential and for the activity of family members you invite into your archive.",
    },
    {
        heading: "3. Founding support & payments",
        body: "One-time and monthly contributions are processed by Stripe. One-time tiers (Founding Member, 12m Premium, Lifetime Premium) grant the benefits described at the time of purchase. Monthly contributions recur until cancelled and can be cancelled at any time with effect from the next billing cycle. Contribution amounts shown at checkout include any applicable taxes.",
    },
    {
        heading: "4. Refunds",
        body: "You can request a full refund of any one-time contribution within 14 days of payment, no questions asked — just email hello@agogenapp.com. Monthly contributions are non-refundable for the current billing period but can be cancelled anytime.",
    },
    {
        heading: "5. Your content & original quality",
        body: "You retain full ownership of everything you upload. You grant Ago GenApp a limited license to store, process, and display your content solely to provide the service to you and your invited family. We store every photo, video, and voice recording exactly as you upload it — we never compress, resize, or re-encode your files, and the original quality is preserved for as long as your archive exists. You are responsible for having the right to upload the content you share, and you agree not to upload unlawful, harmful, or infringing material.",
    },
    {
        heading: "6. Acceptable use",
        body: "You agree not to misuse the service: no attempting to access other families’ archives, no uploading malicious code, no scraping, and no using Ago GenApp for anything unlawful. We may suspend accounts that violate these terms, with notice wherever possible.",
    },
    {
        heading: "7. Service availability",
        body: "We build Ago GenApp to be a permanent home for your memories, and we design for longevity — including export tools so your archive is never locked in. That said, the service is provided “as is” and we do not guarantee uninterrupted availability. If we ever discontinue the service, we commit to giving you at least 12 months’ notice and full export of your data.",
    },
    {
        heading: "8. Limitation of liability",
        body: "To the maximum extent permitted by law, Ago GenApp’s total liability for any claim arising from the service is limited to the amount you paid us in the 12 months preceding the claim. We are not liable for indirect or consequential damages. Nothing in these terms limits liability that cannot be limited under applicable consumer protection law.",
    },
    {
        heading: "9. Changes & contact",
        body: "We may update these terms as the product evolves and will notify you by email before material changes take effect. Continued use after that point constitutes acceptance. Questions: hello@agogenapp.com.",
    },
];

export default function TermsOfService() {
    return (
        <LegalPage
            testId="terms-page"
            title="Terms of Service"
            updated="July 2026"
            intro="These terms govern your use of Ago GenApp and your founding contributions. We’ve kept them short and human — the same way we’re building the product."
            sections={SECTIONS}
        />
    );
}
